import { MasterDataService } from './../masterdata/masterdata.service';
import { Component, OnInit } from '@angular/core';
import { ApgDeliveryService } from '../apg-delivery/apg-delivery.service';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { SenderDTO } from '../masterdata/models/sender-dto';

@Component({
  selector: 'app-apg-deliver-box-manager',
  templateUrl: './apg-deliver-box-manager.component.html',
  styleUrls: ['./apg-deliver-box-manager.component.css']
})
export class ApgDeliverBoxManagerComponent implements OnInit {
  errorHandler: ErrorHandler = new ErrorHandler;
  selectedLabId: string;
  puid: string;
  index: number = 0;
  selectedSender:string;
  senderList: any[] = [];
  blocked=false;
  cols: any[];
  senderBarcodeMap: Map<string,string>;
  senderDateMap: Map<string,boolean>;

  constructor(
    private masterDataService : MasterDataService) {
  }

  ngOnInit() {
    this.selectedLabId = JSON.parse(localStorage.getItem('lab')).lab._id;
    this.puid = localStorage.getItem('PUID');
    this.senderBarcodeMap = new Map<string, string>();
    this.senderDateMap = new Map<string, boolean>();
    this.populateSenders();
    this.cols = [
      { field: 'boxId', header: 'Sender Box ID', width:'20%' },
      { field: 'shipmentId', header: 'Delivery ID', width:'20%' },
      { field: 'sender', header: 'Sender Name', width:'60%' }
    ];
  }

  populateSenders() {
    this.masterDataService.getConfigList(this.selectedLabId, "masender", 0, 100, true).subscribe(
      result => {
        if (result.data) {
          let senders: SenderDTO[] = result.data;
          senders.forEach(sender => {
            this.senderList.push({ label: sender.senderName, value: sender.senderName });
            this.senderList.sort((a, b) => a.label.localeCompare(b.label))
            this.senderBarcodeMap.set(sender.senderName, sender.boxBarcodeFormat);
          });
        }
      },
    );
  }

  clear() {
    this.selectedSender = null;
  }

  onTabChange(event) {
    this.index = event.index;
  }

  regexMatcher(regex: string, barcode: string): boolean {
    let regexp = new RegExp(regex);
    return regexp.test(barcode);
  }

  getCSSClassForPanel(index: number){
    if(index == this.index){
      return 'selected';
    }else{
      return 'unselected';
    }
  }
}
